import React from 'react';
import PropTypes from 'prop-types';
import ReactSVG from 'react-svg';
import map_marker from 'white_marker.svg';
import properties from 'building.svg';
import activities from 'running.svg';
import shopping from 'shopping_bag.svg';
import restaurants from 'silverware.svg';
import services from 'food_platter.svg';
import circle from 'circle.svg';

export default function WhiteMarker({
  type,
  onClick,
  icon,
  active,
  highlighted,
}) {
  let marker = properties;
  switch (type) {
    case 'properties':
      marker = properties;
      break;

    case 'communities':
      marker = properties;
      break;

    case 'activities':
      marker = activities;
      break;

    case 'shopping':
      marker = shopping;
      break;

    case 'restaurants':
      marker = restaurants;
      break;

    case 'services':
      marker = services;
      break;

    default:
      marker = circle;
      break;
  }

  const showIcon = icon && icon.includes('.svg');

  return (
    // eslint-disable-next-line
    <div
      onClick={onClick}
      className={`white-marker ${highlighted ? 'highlighted' : ''}`}
    >
      <ReactSVG
        src={showIcon ? icon : marker}
        svgClassName={`icon ${!type ? 'circle' : ''}`}
        className={active ? 'active-icon-marker' : ''}
      />
      <ReactSVG
        src={map_marker}
        svgClassName="marker"
        className={active ? 'active-map-marker' : 'marker'}
      />
    </div>
  );
}

WhiteMarker.propTypes = {
  type: PropTypes.oneOf([
    'properties',
    'activities',
    'shopping',
    'restaurants',
    'services',
    'communities',
  ]),
  onClick: PropTypes.func,
  icon: PropTypes.string,
  active: PropTypes.string,
  highlighted: PropTypes.bool,
};
